"use client";

import { authClient } from "@/lib/auth-client";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

/**
 * Syncs the route's workspace slug into the session's active organization.
 * Server helpers (getAuth) read the active org from the session, so landing
 * directly on /orgs/[slug] must set it before org-gated reads/actions resolve.
 * router.refresh() re-renders server components with the updated session.
 */
export const DynamicOrgSwitcher = ({ slug }: { slug: string }) => {
  const router = useRouter();
  const { data: sessionData } = authClient.useSession();
  const { data: activeOrg, isPending } = authClient.useActiveOrganization();

  useEffect(() => {
    if (!slug || !sessionData?.user || isPending) return;
    if (activeOrg?.slug === slug) return;

    authClient.organization
      .setActive({ organizationSlug: slug })
      .then(() => router.refresh())
      .catch((error) => {
        // Signed-in visitor on a public workspace they're not a member of.
        console.error("DynamicOrgSwitcher ~ Error setting active organization", error);
      });
  }, [slug, sessionData?.user, activeOrg?.slug, isPending, router]);

  return null;
};
